import patrolHistoryView from './src/patrolHistory/patrolHistoryView.vue'
import patrolRouteDetailView from './src/patrolHistory/patrolRouteDetailView.vue'
import patrolPlanView from './src/patrolPlan/patrolPlanView.vue'

let views = {
    patrolHistoryView,
    patrolRouteDetailView,
    patrolPlanView
};

export default views;
